<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/lock.webp"
  >
    <ng-container i18n
      >Locks refer to access control for the property, including generating and managing lock codes. Actions involve
      sending codes to guests, tracking access logs, and notifying property managers of issues like denied access or
      code resets. Proper lock management ensures secure guest access to the property.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when:</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.DeviceConnected)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.DeviceConnected ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Device Connected
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.DeviceAccessCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.DeviceAccessCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Code Generated
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.DeviceAccessUpdated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.DeviceAccessUpdated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Code Updated
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.DeviceCodeFirstUsed)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.DeviceCodeFirstUsed ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Code First Used
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.DeviceLowBattery)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.DeviceLowBattery ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Battery Low
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.DeviceIssuesRequireAttention)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.DeviceIssuesRequireAttention ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Device Issue
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.DeviceConnected" [ngTemplateOutlet]="connectedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.DeviceAccessCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.DeviceAccessUpdated" [ngTemplateOutlet]="updatedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.DeviceCodeFirstUsed" [ngTemplateOutlet]="firstUsedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.DeviceLowBattery" [ngTemplateOutlet]="lowBatteryEvent"></ng-template>
        <ng-template *ngSwitchCase="events.DeviceIssuesRequireAttention" [ngTemplateOutlet]="issuesEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Device Connected</h6>
    <ng-template [ngTemplateOutlet]="connectedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Code Generated</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Code Updated</h6>
    <ng-template [ngTemplateOutlet]="updatedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Code First Used</h6>
    <ng-template [ngTemplateOutlet]="firstUsedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Battery Low</h6>
    <ng-template [ngTemplateOutlet]="lowBatteryEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Device Issue</h6>
    <ng-template [ngTemplateOutlet]="issuesEvent"></ng-template>
  </div>
</div>

<ng-template #connectedEvent>
  <app-notify-users-automation
    [event]="events.DeviceConnected"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when lock connected"
    [messageSubject]="userNotificationMessages[events.DeviceConnected].subject"
    [messageBody]="userNotificationMessages[events.DeviceConnected].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #createdEvent>
  <app-notify-guest-automation
    [event]="events.DeviceAccessCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send lock code to guest"
    name="Send lock code to guest when new is created"
    [messageSubject]="guestNotificationMessages[events.DeviceAccessCreated].subject"
    [messageBody]="guestNotificationMessages[events.DeviceAccessCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  >
  </app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.DeviceAccessCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when lock code is created"
    [messageSubject]="userNotificationMessages[events.DeviceAccessCreated].subject"
    [messageBody]="userNotificationMessages[events.DeviceAccessCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #updatedEvent>
  <app-notify-guest-automation
    [event]="events.DeviceAccessUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send updated access code to the guest"
    name="Send updated access code to the guest when it is updated"
    [messageSubject]="guestNotificationMessages[events.DeviceAccessUpdated].subject"
    [messageBody]="guestNotificationMessages[events.DeviceAccessUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  >
  </app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.DeviceAccessUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when lock code is updated"
    [messageSubject]="userNotificationMessages[events.DeviceAccessUpdated].subject"
    [messageBody]="userNotificationMessages[events.DeviceAccessUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #firstUsedEvent>
  <app-notify-users-lock-automation
    [event]="events.DeviceCodeFirstUsed"
    [viewType]="viewType"
    [eventSourceType]="type"
    [defaultToAdmins]="true"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) if code is first time used"
    [messageSubject]="userNotificationMessages[events.DeviceCodeFirstUsed].subject"
    [messageBody]="userNotificationMessages[events.DeviceCodeFirstUsed].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-lock-automation>

  <div [ngClass]="viewType === 'table' ? 'autopilot-automation table-view' : ''">
    <div class="panel" [class.active]="toggle2.checked">
      <app-form-switch labelPosition="before" [checked]="true" [inline]="true" [disabled]="true" #toggle2
        ><ng-container i18n>Log entry time</ng-container>
      </app-form-switch>
    </div>
  </div>
</ng-template>

<ng-template #lowBatteryEvent>
  <app-notify-users-lock-automation
    [event]="events.DeviceLowBattery"
    [viewType]="viewType"
    [eventSourceType]="type"
    [defaultToAdmins]="true"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) if battery is low"
    [messageSubject]="userNotificationMessages[events.DeviceLowBattery].subject"
    [messageBody]="userNotificationMessages[events.DeviceLowBattery].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-lock-automation>

  <app-new-incident-automation
    [event]="events.DeviceLowBattery"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Create Incident"
    name="Create an incident for low battery"
    [incident]="lowBatteryIncident"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-incident-automation>
</ng-template>

<ng-template #issuesEvent>
  <app-notify-users-lock-automation
    [event]="events.DeviceIssuesRequireAttention"
    [viewType]="viewType"
    [eventSourceType]="type"
    [defaultToAdmins]="true"
    i18n-label
    i18n-name
    label="Notify user(s) to investigate"
    name="Notify user(s) to investigate in case of any device issue"
    [messageSubject]="userNotificationMessages[events.DeviceIssuesRequireAttention].subject"
    [messageBody]="userNotificationMessages[events.DeviceIssuesRequireAttention].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-lock-automation>

  <app-notify-handler-automation
    [event]="events.DeviceIssuesRequireAttention"
    [handler]="AutomationHandler.DeviceNotifyGuestHandler"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send a message to the guest"
    name="Send a message to the guest when lock has issues"
    [messageSubject]="guestNotificationMessages[events.DeviceIssuesRequireAttention].subject"
    [messageBody]="guestNotificationMessages[events.DeviceIssuesRequireAttention].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  >
  </app-notify-handler-automation>

  <app-new-incident-automation
    [event]="events.DeviceIssuesRequireAttention"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Create Incident"
    name="Create an incident for device issues"
    [incident]="deviceIssueIncident"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-incident-automation>
</ng-template>
